
import Home from "./pages/Home";
import NoPage from "./pages/NoPage";
import Login from "./pages/auth/Login";
import CreateDiary from "./pages/diary/CreateDiary";
import DiaryList from "./pages/diary/DiaryList";
import ManagerList from "./pages/usermanagement/ManagerList";
import StudentList from "./pages/student/StudentList";
import Profile from "./pages/auth/Profile";
import { Routes, Route ,Navigate} from "react-router-dom";
import PasswordUpdate from "./pages/auth/PasswordUpdate";
import EnrollStudent from "./pages/enroll/EnrollStudent";
import EnrollReview from "./pages/enroll/EnrollReview";
import EnrollmentStatistics from "./pages/enroll/EnrollmentStatistics";
import LearnerProgress from "./pages/learner/LearnerProgress";
import Resource from "./pages/course_upload/manage_resource/Index";
import Qualification from "./pages/course_upload/qualification/Index";
import Course from "./pages/course_upload/course/Index";
import ManageTask from "./pages/discussion/task/Index";

import ManageModule from "./pages/online_exam/manage_module/Index";
import ManageSubModule from "./pages/online_exam/manage_sub_module/Index";
import ManageQuestion from "./pages/online_exam/question/Index";
import MultipleOption from "./pages/online_exam/question_option/Index";
import CertificateList from "./pages/online_exam/certificate_list/Index";
import ManageExam from "./pages/online_exam/manage_exam/Index";
import ManageExamUpdate from "./pages/online_exam/manage_exam/Update";
import LearningOutcome from "./pages/course_upload/learning_outcome/Index";
import LearningOutcomeDetails from "./pages/course_upload/learning_outcome_detail/Index";
import Messages from "./pages/messages/Index";
// student side
import ClientLogin from "./pages/studentSide/auth/Login";
import StudentProfile from "./pages/studentSide/auth/Profile";
import StudentUpdatePassword from "./pages/studentSide/auth/PasswordUpdate";
import StudentDashboard from "./pages/studentSide/StudentDashboard";
import ContactUs from "./pages/studentSide/ContactUs";
import TutorSupport from "./pages/studentSide/TutorSupport";
import SResources from "./pages/studentSide/resources/Index";
import StudentProgress from "./pages/studentSide/myProgress/Index";
import ForgetPassword from "./pages/studentSide/auth/ForgetPassword";
import SignUp from "./pages/studentSide/auth/SuginUp";
import StudentCourse from "./pages/studentSide/myCourses/Index";
import StudentCourseTopic from "./pages/studentSide/myCourses/StudentCourseTopic";
import LongQuestionDetail from "./pages/studentSide/myCourses/LongQuestionDetail";
import CourseOutcome from "./pages/studentSide/myCourses/CourseOutcome";
import PaidCourseReading from "./pages/studentSide/myCourses/PaidCourseReading";
import OpenPdf from "./pages/studentSide/myCourses/OpenPdf";
import FreeCourseTopic from  "./pages/studentSide/myCourses/FreeCourseTopic";
import FreeCourseTopicDetail from "./pages/studentSide/myCourses/FreeCourseTopicDetails";
import PaidCourseReleventQuestion from "./pages/studentSide/myCourses/PaidCourseReleventQuestion";
import PayOnline from "./pages/studentSide/payment/PayOnline";
import GuestPayment from "./pages/studentSide/payment/GuestPayment";
import StudentMocExamResult from "./pages/studentSide/StudentMocKExamResult";
import EditVideo from "./pages/course_upload/learning_outcome_detail/EditVideo";
import EditArticle from "./pages/course_upload/learning_outcome_detail/EditArticle";
import EditCaseStudy from "./pages/course_upload/learning_outcome_detail/EditCaseStudy";
import VideoPlay from "./pages/studentSide/myCourses/VideoPlay";
import TakeQuiz from "./pages/studentSide/myCourses/TakeQuiz";
import UserResult from "./pages/mock_exam/user_result/UserResult";
import UserResultDetail from "./pages/mock_exam/user_result/UserResultDetail";
import DubaiDiploma from "./pages/auth/dubaiDiploma";
import DubaiAppointment from "./pages/auth/dubaiAppointment";
import ShowPdf from "./pages/studentSide/myCourses/showPdf";
import Participants from "./pages/studentSide/myCourses/Participants";
import AdminParticipants from "./pages/discussion/participants/Index";
import TeacherQuestions from "./pages/studentSide/myCourses/TeacherQuestions";
import TeacherQuestion from "./pages/discussion/TeacherQuestion/Index";
import ManageGroup from "./pages/discussion/ManageGroup/Index";
import CountryCourse from "./pages/studentSide/auth/CountryCourses";
import CountryCoursesDetails from "./pages/studentSide/auth/CountryCoursesDetails";

function App() {
  return (
    <div>
          { 
          <Routes>
            <Route>
              {/* student side Route */}
              <Route path="/" element={<Navigate to="/login" replace/>} />
              <Route path="/login" element={<ClientLogin />} />
              <Route path="/:branch/diploma" element={<DubaiDiploma />} />
              <Route path="/:branch/appointment" element={<DubaiAppointment />} />
              
              <Route path="/take-quiz/:courseId/:lessionId/:subLessionId?/:sublessonRserial?" element={<TakeQuiz />} />
              <Route path="/forget-password" element={<ForgetPassword />} />
              <Route path="/signup/:id?/:countryId?" element={<SignUp />} />
              <Route path="/country-course" element={<CountryCourse />} />
              <Route path="/country-course-details/:id" element={<CountryCoursesDetails />} />
              
              <Route path="/student-dashboard" element={<StudentDashboard />} />
              <Route path="/student-profile" element={<StudentProfile />} />
              <Route path="/student-password-update" element={<StudentUpdatePassword />} />
              <Route path="/student-contact-us" element={<ContactUs />} />
              <Route path="/student-message" element={<TutorSupport />} />
              <Route path="/student-resources" element={<SResources />} />
              <Route path="/student-progress" element={<StudentProgress />} />
              <Route path="/pdf" element={<ShowPdf />} />

              <Route path="/student-course" element={<StudentCourse />} />
              <Route path="/moc-exam-result" element={<StudentMocExamResult />} />
              <Route path="/paid-course-relevent-question/:lpid/:courseId" element={<PaidCourseReleventQuestion />} />
              <Route path="/paid-course-reading/:lpd_id/:lpid/:unit?" element={<PaidCourseReading />} />

              
              <Route path="/free-course-topic/:course_id/:slider" element={<FreeCourseTopic />} />
              <Route path="/free-course-topic-details/:courseId/:lessionId/:subLessionId?/:sublessonRserial?" element={<FreeCourseTopicDetail />} />

              <Route path="/student-course-topic/:id/:lpid?" element={<StudentCourseTopic />} />
              <Route path="/course-participants/:course_id/:lpid" element={<Participants />} />
              <Route path="/teacher-questions/:course_id/:course_task_id/:lpid?" element={<TeacherQuestions />} />
              <Route path="/long-question-detail/:courseId/:lqsId" element={<LongQuestionDetail />} />

              <Route path="/edit-video/:id" element={<EditVideo />} />
              <Route path="/video-play/:video" element={<VideoPlay />} />
              <Route path="/edit-article/:id" element={<EditArticle />} />
              <Route path="/edit-case-study/:id" element={<EditCaseStudy />} />

              <Route path="/student-course-outcome/:lpid/:unit?" element={<CourseOutcome />} />
              <Route path="/student-relevant-questions/:course_id/:lpid" element={<OpenPdf />} />
              <Route path="/online-payment" element={<PayOnline />} />
              <Route path="/guest-online-payment" element={<GuestPayment />} />

              {/*end student side route */}
              <Route path="/admin" element={<Login />} />
              <Route path="dashboard" element={<Home />} />
              <Route path="add-diary" element={<CreateDiary />} />
              <Route path="/diary-list" element={<DiaryList />} />
              <Route path="/participants-list" element={<AdminParticipants />} />
              <Route path="user-result" element={<UserResult />} />
              <Route path="user-result-detail/:user_id" element={<UserResultDetail />} />
              <Route path="/manager-list" element={<ManagerList />} />
              <Route path="/enroll-learners-information" element={<EnrollStudent />} />
              <Route path="/enroll-review" element={<EnrollReview />} />
              <Route path="/learners-list" element={<StudentList />} />
              <Route path="/learning-outcome" element={<LearningOutcome />} />
              <Route path="/learning-outcome-details" element={<LearningOutcomeDetails />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/password-update" element={<PasswordUpdate />} />
              <Route path="/enrollment-statistics" element={<EnrollmentStatistics />} />
              <Route path="/learner-progress" element={<LearnerProgress />} />
              <Route path="/manage-resource" element={<Resource />} />
              <Route path="/manage-qualification" element={<Qualification />} />
              <Route path="/manage-course" element={<Course />} />
              <Route path="/manage-task" element={<ManageTask />} />
              <Route path="/manage-task-question" element={<TeacherQuestion />} />
              <Route path="/manage-group" element={<ManageGroup />} />
              <Route path="/manage-module" element={<ManageModule />} />
              <Route path="/manage-sub-module" element={<ManageSubModule />} />
              <Route path="/manage-question" element={<ManageQuestion />} />
              <Route path="/multiple-option" element={<MultipleOption />} />
              <Route path="/certificate-list" element={<CertificateList />} />
              <Route path="/manage-exam" element={<ManageExam />} />
              <Route path="/messages" element={<Messages/>} />
              <Route path="/manage-exam/update/:id" element={<ManageExamUpdate />} />
              <Route path="*" element={<NoPage />} />
            </Route>
          </Routes> 
          }
    </div>
  );
}

export default App;
